import { Box, HStack, IconButton, Shadow, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';

import { TextSkeleton } from '../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { ItemSeparator } from '../DynamicIOProductTable/desktop';

import { DynamicIOProductTableLoadingProps } from '.';

export const DynamicIOProductTableMobileLoading: React.FC<DynamicIOProductTableLoadingProps> = ({
  rowsCount = 1,
  mobileDetailRowsCount = 3,
  showAction = true,
}) => {
  return (
    <VStack pt="stack.xxs">
      {Array.from({ length: rowsCount }, (_, rowIndex) => (
        <Box key={`mobile-row-${rowIndex}`}>
          {rowIndex > 0 && <ItemSeparator />}
          <Shadow level={1} p="inset.xs" borderRadius={BoxBorder.heavy}>
            <VStack space="stack.xxxs">
              <VStack space="stack.quarck">
                <TextSkeleton w="20%" h="stack.nano" />
                <TextSkeleton w="55%" />
              </VStack>

              <VStack space="stack.nano">
                {Array.from({ length: mobileDetailRowsCount }, (__, detailIndex) => (
                  <Box key={`mobile-detail-${rowIndex}-${detailIndex}`}>
                    <HStack justifyContent="space-between" alignItems="center">
                      <TextSkeleton w="30%" />
                      <TextSkeleton w="35%" />
                    </HStack>
                    {detailIndex < mobileDetailRowsCount - 1 && (
                      <Box h="1px" w="full" bg="neutral.lightest" mt="stack.nano" />
                    )}
                  </Box>
                ))}
              </VStack>

              <HStack justifyContent="space-between" alignItems="center">
                <TextSkeleton w="35%" />
                {showAction && (
                  <IconButton
                    alignSelf="flex-end"
                    isDisabled
                    testId="dynamic-io-product-table-mobile-loading"
                    icon="ArrowRight"
                    p={0}
                    backgroundColor="transparent"
                    iconColor="neutral.medium"
                    iconSize="xs"
                  />
                )}
              </HStack>
            </VStack>
          </Shadow>
        </Box>
      ))}
    </VStack>
  );
};
